import * as React from 'react'
import { styles } from './useStyles'
import Link from '@mui/material/Link'

type Props = {
  href: string
  label: string
}

export function GridLink(props: Props) {
  const { href, label } = props

  return (
    <Link href={href} sx={styles.link}>
      {label}
    </Link>
  )
}
